import { useMemo, useState } from 'react';
import type { TocSection } from './OnThisPageNav';

/** Filters a TocSection[] by section/item name. A section-name match keeps all its items. */
export function useTocSearch(sections: TocSection[]) {
  const [query, setQuery] = useState('');

  const filteredSections = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return sections;
    return sections
      .map((section) => {
        if (section.label.toLowerCase().includes(q)) return section;
        const groups = section.groups
          .map((group) => ({ ...group, items: group.items.filter((item) => item.title.toLowerCase().includes(q)) }))
          .filter((group) => group.items.length > 0);
        return groups.length > 0 ? { ...section, groups } : null;
      })
      .filter((section): section is TocSection => section !== null);
  }, [sections, query]);

  return { query, setQuery, filteredSections };
}
